export default "__VITE_ASSET__FjExHUXU__"